<template>
	<section class="block image large-image" :class="{ scroll : $getField('large_image_scroll', data) == true }">
        <div class="inner" :class="{ 'has-padding' : $getField('large_image_padding', data) == true }" :style="{ backgroundColor: $getField('large_image_colour', data) }">
            <img v-lazy="'https://api.alt-design.net/api/image/' + $getField('large_image_image', data)" />
            <div class="overlay">
            </div>
        </div>

    </section>
</template>

<script>
export default {
  props: {
    data: [Array, Object]
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/Projects/Rows/LargeImage.vue